import React from 'react';
import DepartmentsAdminLayout from '../components/administration/DepartmentsAdminLayout';

function DepartmentsPage() {
  return <DepartmentsAdminLayout />;
}

export default DepartmentsPage;
